import { render, staticRenderFns } from "./NormalButton.vue?vue&type=template&id=f7d95012&scoped=true"
import script from "./NormalButton.vue?vue&type=script&lang=js"
export * from "./NormalButton.vue?vue&type=script&lang=js"
import style0 from "./NormalButton.vue?vue&type=style&index=0&id=f7d95012&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7d95012",
  null
  
)

export default component.exports